import { Box } from '@factorialco/deprecated-design-system'
import { Money } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import RateConfigurationSection from 'modules/expenses/pages/settings/Content/RateConfigurations'
import SectionInfo from 'modules/expenses/pages/settings/ExpensePolicy/Components/_SectionInfo'

interface Props {
  hasPerDiemsFeature: boolean
  hasNewPerDiemFeature: boolean
}

const Rates = ({ hasPerDiemsFeature, hasNewPerDiemFeature }: Props) => {
  return (
    <Box flexDirection="column" gap="s24" paddingX="s24" flexGrow>
      <SectionInfo
        icon={Money}
        title={i18n.t('expenses_v2.settings.rate_configurations.title')}
        description={i18n.t('expenses_v2.settings.rate_configurations.description')}
      />

      <RateConfigurationSection
        hasPerDiemsFeature={hasPerDiemsFeature}
        hasNewPerDiemFeature={hasNewPerDiemFeature}
        hideTitle
      />
    </Box>
  )
}

export default Rates
